// 单个工艺单元的参数设置组件
import React, { useState, useEffect } from "react";
import MyIcon from "../../../../components/MyIcon";
import { Switch, message } from "antd";
import classnames from 'classnames';
import { stationflowchart } from '@api/newApi';
import LLJImg from '../../../../assets/gylc-llj-icon.png'
import YWYImg from '../../../../assets/gylc-ywy-icon.png'

export default ({ getWidth, id, currentConfig, handleSetLoding }) => {
  const [config, setConfig] = useState({})
  // 查询选择工艺单元所对应的设备信息
  const findCommandsByParams = () => {
    stationflowchart.findDisplayByProcessunitId({ stationId: id, processunitId: currentConfig }).then((res) => {
      if (res.status == 0) {
        let data = []
        res.data.map((mm, idx) => {
          data.push(mm.devId)
        })
        data = [...new Set(data)]
        let resData = []
        data.map((nn) => {
          let obj = {
            devId: nn,
            // 阀门状态,0开，1关,-1不展示阀门状态
            isShowFMStatus: -1,
            // 是否含有故障点位
            hasGZStatus: false,
            // 是否含有启停点位
            hasQTStatus: false,
            isGZ: false, //设备是否故障
            isTZ: false, //设备是否停止
            gatherType: 0, //0普通点位，1仪表类
            gather: { //点位数据
              YBType: [], //仪表类型
            },
          };
          res.data.map((mm, index) => {
            if (mm.devId == nn) {
              obj.deviceName = mm.deviceName;
              let three = mm.gatherDevPointValue.split('_')[2];
              let four = mm.gatherDevPointValue.split('_')[3];
              // 故障
              if (three == 'ZG') {
                obj.hasGZStatus = true;
                if (mm.val == 1) {
                  obj.isGZ = true;
                }
              }
              // 停止
              if (three == 'QT') {
                obj.hasQTStatus = true;
                if (mm.val == 0) {
                  obj.isTZ = true;
                }
              }
              //仪表类点位
              if (four == 'Y') {
                obj.gatherType = 1;
                obj.gather.YBType.push(mm);
              }

              switch (three) {
                case 'KG': //开关控制
                  if (four == 'C') { //控制类
                    obj.gather.KG = {
                      ...mm,
                    }
                  }
                  break;
                case 'FKG': //阀门开关状态
                  obj.isShowFMStatus = mm.val; //1开到位，0关到位
                  break;
                case 'SZ': //手动/自动控制
                  obj.gather.SZD = {
                    ...mm,
                  }
                  break;
                case 'PL': //频率
                  obj.gather.PL = {
                    ...mm,
                  }
                  break;
                case 'ZG': //状态 (0正常、1故障)
                  obj.gather.ZT = {
                    ...mm,
                  }
                  break;
                default:
                  break;
              }
            }
          })
          resData.push(obj)
        })
        getWidth(resData.length);

        // 设备排序，普通设备在前，仪表在后
        let yibiaoArr = [];
        let deviceArr = [];
        resData.map((mm, idx) => {
          if (mm.gather.YBType.length != 0) {
            yibiaoArr.push(mm);
          } else {
            deviceArr.push(mm);
          }
        })
        let allDeviceArr = deviceArr.concat(yibiaoArr);
        setConfig([...allDeviceArr]);
      }
    });
  };
  useEffect(() => {
    findCommandsByParams();
    return () => { };
  }, []);

  // 修改设备点位控制信息（开关）。type：1,选中自动，不让修改开关点位信息
  const switchChange = (item, type, val) => {
    if (type == 1) {
      return false;
    }
    const data = {
      gatherDevPointId: item.gatherDevPointId,
      processunitId: currentConfig,
      stationId: id,
      val, //: item.val==0?1:0
    };
    handleSetLoding(true);
    updataContral(data)
  };
  // 修改手自动点位控制信息
  const handleAutoChange = (SZD, val) => {
    const data = {
      gatherDevPointId: SZD.gatherDevPointId,
      processunitId: currentConfig,
      stationId: id,
      val,
    };
    handleSetLoding(true);
    updataContral(data)
  }

  // 修改控制点位接口
  const updataContral = (data) => {
    stationflowchart.update(data).then((res) => {
      handleSetLoding(false);
      findCommandsByParams();
      if (res.status == 0) {
        message.success("修改成功");
      }
    });
  }

  return (
    <div className="config-con">
      {config.length > 0 &&
        config.map((item, index) => {
          // 仪表类设备点位数据
          if (item.gatherType == 1) {
            return (
              <div
                key={index}
                className={"config-item config-yibiao"}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <div className="config-title" style={{ flex: 0.5, border: 0 }}>
                  <span>{item.deviceName}</span>
                </div>
                <div className="content-box" style={{ flex: 0.5 }}>
                  {
                    item.gather.YBType.length > 0 &&
                    item.gather.YBType.map((mm, idx) =>
                    (
                      <div className={classnames({
                        "item": true,
                      })}
                        title={mm.gatherDevPointName + mm.val + mm.gatherDevPoiParUnit}
                        key={idx}>
                        <span>{mm.gatherDevPointName}</span>
                        <b>{mm.val} {mm.gatherDevPoiParUnit}</b>
                      </div>
                    ))
                  }
                </div>
                {/* 图标 */}
                {/* 液位计 */}
                {item.gather.YBType[0].gatherDevPointValue.split('_')[1] == 'YWJ' && <img className="icon-bg" src={YWYImg} />}
                {/* 流量计 */}
                {item.gather.YBType[0].gatherDevPointValue.split('_')[1] == 'LLJ' && <img className="icon-bg" src={LLJImg} />}
              </div>
            );
          }
          // 普通点位
          if (item.gatherType == 0) {
            return (
              <div
                key={index}
                className={"config-item"}
                style={{
                  display: 'flex', alignItems: 'center', width: '100%',
                  height: 'auto'
                }}
              >
                <div className="config-title" style={{ flex: 0.5, border: 0, }}>
                  <span style={{ textAlign: 'left', padding: '0 20px' }}>{item.deviceName}</span>
                </div>
                <div className="con " style={{ flex: 0.5 }}>
                  {/* 状态展示区 */}
                  <div className="showStatus-area">
                    { //非阀门设备
                      item.isShowFMStatus == -1 &&
                      <>
                        <div className={classnames({
                          item: true,
                          nothing: !item.hasQTStatus,
                          green: !item.isTZ
                        })}>
                          <div className="light"></div>
                          <div className="desc">运行</div>
                        </div>
                        <div className={classnames({
                          item: true,
                          nothing: !item.hasQTStatus,
                          yellow: item.isTZ
                        })}>
                          <div className="light"></div>
                          <div className="desc">停止</div>
                        </div>
                      </>
                    }
                    { // 阀门
                      item.isShowFMStatus != -1 &&
                      <>
                        <div className={classnames({
                          item: true,
                          green: item.isShowFMStatus == 1,
                          nothing: item.isShowFMStatus == -1
                        })}>
                          <div className="light"></div>
                          <div className="desc">开</div>
                        </div>
                        <div className="item blue nothing">
                          <div className="light"></div>
                          <div className="desc">中间态</div>
                        </div>
                        <div className={classnames({
                          item: true,
                          yellow: item.isShowFMStatus == 0,
                          nothing: item.isShowFMStatus == -1
                        })}>
                          <div className="light"></div>
                          <div className="desc">关</div>
                        </div>
                      </>
                    }
                    <div className="split-line"></div>
                    <div className={classnames({
                      item: true,
                      green: !item.isGZ,
                      nothing: !item.hasGZStatus
                    })}>
                      <div className="light"></div>
                      <div className="desc">正常</div>
                    </div>
                    <div className={classnames({
                      item: true,
                      red: item.isGZ,
                      nothing: !item.hasGZStatus
                    })}>
                      <div className="light"></div>
                      <div className="desc">故障</div>
                    </div>
                    <div className="split-line"></div>
                    <div className={classnames({
                      item: true,
                      nothing: !item.gather.SZD,
                      green: item.gather.SZD && item.gather.SZD.val == 0,
                    })}>
                      <div className="light"></div>
                      <div className="desc">手动</div>
                    </div>
                    <div className={classnames({
                      item: true,
                      nothing: !item.gather.SZD,
                      green: item.gather.SZD && item.gather.SZD.val == 1,
                    })}>
                      <div className="light"></div>
                      <div className="desc">自动</div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        })}
    </div>
  );
};
